import { types as t } from 'mobx-state-tree';

export const UserRole = t.enumeration('Role', [
  'superadmin',
  'admin',
  'recruiter',
  'user',
  'limited',
]);
